<template>
  <div class="card-wrapper">
    <!--头部-->
    <div class="head box">
      <div>相册</div>
      <div>
        <Button type="primary" @click="addPic">
          上传
          <input
            type="file"
            id="addAlbum"
            class="upload-btn"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="uploadImg"
            hidden
          >
        </Button>
      </div>
    </div>
    <div class="content" >
      <!--图片-->
      <div class="pic-wrapper box">
        <div v-for="(item,index) in picList" class="pic-item" @mouseenter="showZhezhao = true;picIndex=index" @mouseleave="showZhezhao = false;picIndex=index">
          <img :src="item.path" />
          <!--鼠标悬浮遮罩层-->
          <div class="zhezhao box" v-if="showZhezhao && picIndex==index">
            <div class="text" @click="preview(index)">查看</div>
            <div class="text" @click="delPic(item)">删除</div>
          </div>
        </div>
      </div>
      <!--页码-->
      <div class="box page-footer">
        <Page :total="total" show-total :page-size="12" @on-change="pageChange" />
      </div>
    </div>
    <!--上传图片-->
    <upload-img
      class="upload-img"
      :imgArr="imgArr"
      @saveImg="saveImg"
      :isClick="isClick"
      :isClickE="isClickE"
      :imgNumber="imgNumber"
      :fixedNumber="fixedNum"
    >
    </upload-img>
    <!--预览图片-->
    <preview-img
      v-if="isShowImg"
      :imgArr="previewList"
      :currentIndex="currentIndex"
      v-on:closePreview="closePreview"
    ></preview-img>
    <Spin fix v-if="showSpin">
    </Spin>
  </div>
</template>

<script>
  import uploadImg from "@/components/uploadImg";
  import previewImg from "../../../components/previewImg";
  export default {
    name: 'orgAlbum',
    props:{
      id:null,
      comeType: null
    },
    components:{
      uploadImg,
      previewImg
    },
    data () {
      return {
        picList: [],
        showZhezhao:false,//是否显示图片上的遮罩层
        picIndex:0,
        isClick: 0,
        isClickE: "",
        fixedNum:[53,32],
        imgArr:[],
        imgNumber:5,
        currentIndex:0,
        previewList:[],//预览图片数组
        isShowImg:false,//控制是否显示预览
        page:1,
        rows:12,
        showSpin:false,
        total:0,
      }
    },
    watch:{
      id (newV,oldV) {
        this.getPicList()
      }
    },
    methods:{
      getPicList () {
        this.showSpin = true
        var url = this.urlobj.getOrgAlbum
        this.$post(url,{
          pageNum : this.page,
          pageSize : this.rows,
          orgId : this.id,
        }).then(res => {
          this.total = res.total
          this.showSpin = false
          this.picList = res.rows.map(item => {
            return {
              isOrg:item.isOrg,
              path:item.filePath,
              id:item.id,
              fileId:item.fileId
            }
          })
        })
      },
      // 页码改变
      pageChange (num) {
        this.page = num
        this.getPicList()
      },
      uploadImg(e) {
        this.isClickE = e;
        this.isClick++;
      },
      // 添加图片 触发上传图片按钮
      addPic() {
        this.fixedNum = [53,32]
        let oInput = document.getElementById("addAlbum");
        oInput.click();
      },
      saveImg (data) {
        var url = this.urlobj.saveOrgPic
        this.$post(url,{
          orgId:this.id,
          fileId:data.id,
          picUrl:data.path,
          comeType: this.comeType
        }).then(res => {
          this.page = 1
          this.getPicList(this.id)
        })
        // this.picList.unshift(data)
      },
      delPic (item) {
        console.log(item)
        var url = this.urlobj.delOrgPic(item.fileId)+'?id='+item.id+'&isOrg='+item.isOrg
        this.$delete(url).then(res => {
          this.$Message.success('删除成功')
          this.page = 1
          this.getPicList(this.id)
        })
      },
      //预览图
      preview(index) {
        //预览
        var list = this.picList
        var _list = list.map((item, _index) => {
          return {
            id: _index,
            path: item.path,
            isHeight: 1
          };
        });
        var img1 = _list.slice(0, index);
        var img2 = _list.slice(index);
        this.currentIndex = index;
        this.previewList = img2.concat(img1);
        this.isShowImg = true;
      },
      //取消预览
      closePreview () {
        this.isShowImg = false;
      }
    }
  }
</script>

<style scoped lang="less">
  .card-wrapper /deep/ .ivu-btn{
    padding: 1px 15px 2px;
  }
  .card-wrapper /deep/ .ivu-page-item{
    background: #f1f1f1;
  }
  .card-wrapper /deep/ .ivu-page-prev, .ivu-page-next{
    background: #f1f1f1;
  }
  .card-wrapper /deep/ .ivu-page-next{
    background: #f1f1f1 ;
  }
  .card-wrapper {
    width: 98%;
    margin: auto;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    position: relative;
  }
  .head {
    padding: 0 20px;
    border-bottom: 1px solid #ddd;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    font-size: 19px;
    color: #4b4b4b;
  }
  .content{
    padding: 20px 0 20px 20px;
    .pic-wrapper {
      flex-wrap: wrap;
      .pic-item{
        width: 265px;
        height: 160px;
        margin-right: 20px;
        margin-bottom: 20px;
        position: relative;
        img{
          width: 100%;
          height: 100%;
          border-radius: 7px;
        }
        .zhezhao{
          background: rgba(0,0,0,0.5);
          justify-content: center;
          align-items: center;
          line-height: 1;
          position: absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          font-size: 18px;
          border-radius: 7px;
          .text{
            color:#fff;
            &:first-child{
              margin-right: 10px;
            }
            &:hover{
              color:#92aee2
            }
          }
        }
      }
    }
    .page-footer{
      justify-content: flex-end;
      padding-right: 20px;
    }
  }
</style>
